
<style scoped>
.upload_form{
	display: block;
	height: 200px;
	width: 400px;
	background: #50c65d36;
	margin: auto;
	padding-top:40px;
	border-radius: 4px;
	background: #FFFF;
	text-align: center;
	border: 2px solid rgba(109, 124, 142, 0.5);
	box-sizing: border-box;
	box-shadow: 0px 5px 10px rgba(162, 158, 158, 0.2);
	border-radius: 10px;
	font-weight: 600;
}

div.file-listing{
	width: 400px;
	margin: auto;
	padding: 10px;
	border-bottom: 1px solid #ddd;
}

div.remove-container a{
	color: red;
	cursor: pointer;
}

</style>
<template>
	<div>
		
		<!-- confirmation dialog box -->
		<v-dialog v-model="dialog.flag" width="500" >
			<v-card >
				<p class="text-right pr-3 pt-1" style="margin-bottom:-10px !important">
					<v-icon color="#8F8F8F" small @click="dialog.flag= false"> mdi-window-close </v-icon>
				</p>
				<v-card-text class="flex-column text-center py-8" v-cloak @drop.prevent="addFile" @dragover.prevent>

					<div id="file-drag-drop">
						<label class="cursor-pointer ">
							<input  type="file" ref="files" 
							@change="browseFile($event)"
							accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"  hidden >
							<form ref="csvfileform"  class="upload_form text-center">
								<img src="@/assets/upload.svg" alt="" width="30px">
								<br>
								<p class="drop-files">Drop the files here!</p>
								<p class="drop-files">or</p>
								<p class="drop-files">click here to browse file</p>
							</form>
						</label>

						<div  class="file-listing" v-if="file" >
							<!-- <img class="preview" v-bind:ref="'preview'+parseInt( key )"/> -->
							{{file.name }}
							<div class="remove-container">
								<a class="remove" @click="removeFile()">Remove</a>
							</div>
						</div>

						<v-btn outlined  color="primary" 
						@click="submitFiles()" 
						class=" mt-8 br-8 border-w-2"
						:disabled="file?false:true"
						:loading="btn_loading"
						>	
						<b>{{$lang.UPLOAD}} </b>
					</v-btn>	

					<div class="mt-4">
						Click
						<a href="https://api.themedx.in/media/medxSampleProduct.csv" target="_blank">here</a>
						to download the formate
					</div> 

				</div>

			</v-card-text>
		</v-card>
	</v-dialog>

</div>
</template>
<script>
var accepted_formate=['application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','.csv']
export default{
	props:['dialog'],
	data(){
		return {
			dragAndDropCapable: false,
			file:null,
			btn_loading:false,
		}
	},

	mounted(){
		const self=this
		this.dragAndDropCapable = this.determineDragAndDropCapable();

		if(this.$refs.csvfileform==undefined)
			return false
		if( this.dragAndDropCapable ){

			['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {


				this.$refs.csvfileform.addEventListener(evt, function(e){
					e.preventDefault();
					e.stopPropagation();
				}.bind(this), false);
			}.bind(this));


			this.$refs.csvfileform.addEventListener('drop', function(e){

				/* Apply validations */ 
				if (e.dataTransfer.files.length>1){
					this.$store.dispatch('snackbar/setSnackbar', {flag:true, text:this.$messages.MULTIPLE_FILE_NOT_SUPPORTED, color:this.$keys.WARNING })
					return false
				}
				if(!accepted_formate.includes(e.dataTransfer.files[0]['type'])){
					self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.INVALID_FILE, color:'error' })
					return false;
				}
				if(e.dataTransfer.files[0].size>(1024*1024*this.$keys.MAX_FILE_SIZE)){
					self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.MAX_FILE_SIZE_ERROR+ this.$keys.MAX_FILE_SIZE, color: this.$keys.ERROR })
					return false;
				}

				this.file=e.dataTransfer.files[0]


			}.bind(this));
		}
	},
	methods: {
		determineDragAndDropCapable(){
			var div = document.createElement('div');

			return ( ( 'draggable' in div )
				|| ( 'ondragstart' in div && 'ondrop' in div ) )
			&& 'FormData' in window
			&& 'FileReader' in window;
		},

		/* upload Csv*/
		browseFile(e){
			console.log(e.target.files[0]['type'])
			const self= this		
			self.csv_loading=true;

			// if(!accepted_formate.includes(e.target.files[0]['type'])){
			// 	self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.INVALID_FILE, color:'error' })
			// 	return false;
			// }
			if(e.target.files[0].size>(1024*1024*this.$keys.MAX_FILE_SIZE)){
				self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.MAX_FILE_SIZE_ERROR+ this.$keys.MAX_FILE_SIZE, color: this.$keys.ERROR })
				return false;
			}
			this.file=e.target.files[0]
		},

		/* Submits the files to the server */
		submitFiles(){
			const self=this
			let form = new FormData();
			form.append('file', this.file);
			self.btn_loding=true

			const successHandler = (response) => {
				if (response.data.success){
					self.dialog.flag=false
					self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.FILE_UPLOADED, color: this.$keys.SUCCESS })
					this.$emit("update-product-list");
				}
			};
			const finallyHandler = () => {
				self.btn_loding=false
			};
			
			this.request_POST(self,this.$urls.UPLOAD_PRODUCT_EXCEL,form,successHandler,null,null,finallyHandler)



		},

		removeFile(){
			this.file=null;
		},

		addFile(e) {
			let droppedFiles = e.dataTransfer.files;
			if(!droppedFiles) return;
			// this.files.push(droppedFiles[0])
			
			// ([...droppedFiles]).forEach(f => {
				// this.files.push(f);
			// });
		},
	}
}

</script>